import React from 'react';
import { FormGroup } from 'reactstrap';
import { GreyLabel, Colors } from '../../../../utils/budget-tool-specific';
import Select from "react-select";

const FormInputMulti = (props) => {

    const handleMultiChange = (selected) => {

        let newData = {...props.data};
        let array =[];
        Object.entries(selected).map((element) => {
            array.push(element[1].label);
            return 1;
        });
        newData[props.id].value = array;
        props.setData(newData);
    };

    const customStyles = {
        option: (provided) => ({
          ...provided
        }),
        control: (provided) => ({
          // none of react-select's styles are passed to <Control />
          ...provided,
          backgroundColor: 'white'
        }),
        singleValue: (provided, state) => {
          const opacity = state.isDisabled ? 0.5 : 1;
          const transition = 'opacity 300ms';
      
          return { ...provided, opacity, transition };
        }
      }

    return ( 
        <React.Fragment>
            <FormGroup>
                <GreyLabel for={props.id}>{props.title}</GreyLabel>
                <Select
                    value={props.value}
                    placeholder=""
                    isMulti
                    name="colors"
                    options={props.options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isDisabled={props.disabled !== undefined}
                    onChange={e => handleMultiChange(e)}
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                            ...theme.colors,
                            primary25: Colors.primaryLight,
                            danger: Colors.primaryDark,
                            dangerLight: Colors.primaryDark,
                            primary: 'white',
                            neutral10: Colors.primaryLight,
                            neutral0: 'white',
                            neutral5: Colors.primaryDark,
                            neutral20: Colors.primaryLight,
                            neutral30: Colors.primaryDark,
                            neutral40: Colors.primaryDark,
                            neutral50: Colors.primaryDark,
                            neutral60: Colors.primaryDark,
                            neutral70: Colors.primaryDark,
                            neutral80: Colors.primaryDark,
                            neutral90: Colors.primaryAccent,
                        },
                        
                    })}
                    styles={customStyles}
                />
            </FormGroup>
        </React.Fragment>
    )

}

export default FormInputMulti;